// src/components/Toast.jsx
import React, { useEffect, useState } from "react";

export default function Toast({ message, onDone }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) return;
    setVisible(true);
    const t = setTimeout(() => {
      setVisible(false);
      setTimeout(onDone, 400);
    }, 2800);
    return () => clearTimeout(t);
  }, [message, onDone]);

  if (!message) return null;

  return (
    <div style={{
      position: "fixed", bottom: "24px", right: "24px",
      background: "#4A7C59", color: "#fff",
      padding: "12px 20px", borderRadius: "8px",
      fontSize: "0.88rem", fontWeight: 500,
      zIndex: 300, display: "flex", alignItems: "center", gap: "8px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
      transform: visible ? "translateY(0)" : "translateY(80px)",
      opacity: visible ? 1 : 0,
      transition: "transform 0.35s cubic-bezier(0.34,1.56,0.64,1), opacity 0.35s",
    }}>
      ✓ {message}
    </div>
  );
}
